import { getItemCategoryByName } from '@app/api/category';
import { HsCodeSuggestionApiResponse } from '@app/api/category/types';
import { useAbortSignal } from '@app/hooks/general/useAbortSignal';
import { useCompanyId } from '@app/hooks/general/useCompanyId';
import { snakeToCamelCase } from '@app/utils/snakeCamelTransform';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

const GET_HS_CODE_BY_NAME_SUGGESTION = 'GET_HS_CODE_BY_NAME_SUGGESTION';

export function useGetHSCodeSuggestionByNameQuery(
  keyword: string
): UseQueryResult<HsCodeSuggestionApiResponse[], Error & AxiosError> {
  const companyId = useCompanyId();
  const { newAbortSignal, resetAbortSignal } = useAbortSignal();
  return useQuery({
    queryKey: [GET_HS_CODE_BY_NAME_SUGGESTION, keyword],
    queryFn: async () => {
      const res = snakeToCamelCase(
        await getItemCategoryByName({ companyId, keyword, signal: newAbortSignal() })
      );
      resetAbortSignal();
      return res;
    },
    enabled: !!keyword && keyword.length > 1,
  });
}
